import React, { useCallback, useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { setDuonutState } from "../../redux/slices/duonutSettings";
import { setUserActivity, updateIsEditing } from "../../redux/slices/userActivity";
import Activity from "./activity";
import Video from "./activity/Video/Video";
import ActivityPagination from "./activityPagination";
import "./designActivity.css";

import TextEditor from "./TextEditor";

export default function DesignActivity({ slidesActive, setSlidesActive }) {
  const dispatch = useDispatch();
  const { videoVisible, isVideo } = useSelector((state) => state.userActivity);
  const [videoProgress, setVideoProgress] = useState(0)
  // const { width } = useWindowDimensions();
  const playerRef = useRef(null)
  const [videoDetails, setVideoDetails] = useState({
    progress: 0
  })
  const { video, video_url } = useSelector((state) => state.duonutSettings.settings);

  const onProgress = useCallback((res) => {
    // console.log('progress', res);
    if (res === null) return
    // if (videoProgress === 0) return
    let progress = Math.floor(res.playedSeconds)
    setVideoDetails({
      ...videoDetails,
      progress
    })
  }, [])

  // console.log('video', video)
  // const onProgress = (res) => {
  //   console.log('progress', res);
  //   if (res === null) return
  //   // if (videoProgress === 0) return
  //   let progress = Math.floor(res.playedSeconds)
  //   setVideoDetails({
  //     ...videoDetails,
  //     progress
  //   })
  //   // setVideoProgress(progress)
  //   // dispatch(updateVideoProgress({ videoProgress: progress }))
  // }

  
// console.log({isVideo});
// console.log({videoVisible});
// console.log({video_url});

  useEffect(() => {
    return () => {
      dispatch(updateIsEditing({ isEditing: false }));
    };
  }, []);

  return (
    <div className="activity_container">
      <div className="activity_container__wrapper">
        <TextEditor />
        {isVideo && videoVisible ? (
          <div className="activity_container__activity_main" style={{ justifyContent: "center" }}>
            <div className="activity_container__activity">
              <div className="activity_container__activity_wrapper" style={{ backgroundColor: "#efefef", padding: 0 }}>
                <Video onProgress={onProgress}
                  playerRef={playerRef} video_url={video_url} video={video} />
              </div>
            </div>
          </div>
        ) : (
          <Activity playerRef={playerRef} />
        )}
        {/* {width <= 1275 ? (
          slidesActive && <ActivityPagination playerRef={playerRef} 
          setSlidesActive={setSlidesActive} slidesActive={slidesActive}
         
            videoDetails={videoDetails} />
        ) : ( */}
          <ActivityPagination playerRef={playerRef}
            setSlidesActive={setSlidesActive}
            slidesActive={slidesActive}
            videoDetails={videoDetails} />
        {/* )} */}
      </div>
    </div>
  );
}
